import axios from 'axios';

export const login = (payload) => {
  return axios.post('/login', payload).then((res) => {
    if (res.data.code === 0 || res.data.code === 202) {
      return res.data;
    }
  });
};

export const verify2FA = (payload) => {
  return axios.post('/validate_2fa', payload).then((res) => {
    if (res.data.code === 0) {
      return res.data;
    }
  });
};
